import { Component, Input } from "@angular/core";
import { UpsellWhyContent } from "src/app/models/upsell-why-content";

@Component({
  selector: "upsell-why",
  templateUrl: "upsell-why.html",
  styleUrls: ["upsell-why.scss"],
})

export class UpsellWhyComponent {

  /**
   * @apiDescription Used to render content
   * @apiParam {content} Array containing content objects
   * @apiParamExample {content} Example input Array
   *  [{
   *    label: 'Step 1',
        active: false,
        showCheck: true
      }, {
   *    label: 'Step 2',
   *    active: true,
   *    showCheck: true
   *  }]
   */
  @Input() content: UpsellWhyContent[] = [];
  @Input() upsellwhyImage: string = ``;
  
  constructor() {}

  ngOnInit() {
    console.log('UpsellWhyComponent received content:', this.content);
  }

  trackByFn(index: number, item: UpsellWhyContent): string | number {
    return item?.id || index;
  }
}